import { render, staticRenderFns } from "./QuizQuestionBuilder.vue?vue&type=template&id=3f74934e"
import script from "./QuizQuestionBuilder.vue?vue&type=script&lang=js"
export * from "./QuizQuestionBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports